import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useEffect, useState } from 'react';

export type refetchArr = () => any;
type Props = {
  refetch?: () => any;
  refetchArr?: refetchArr[];
  reloaderSize?: any;
};

export default function Reload({ refetch, refetchArr, reloaderSize }: Props) {
  const [loading, setLoading] = useState(false);
  const [tempState, setTempState] = useState<number>();

  const handleRefetch = () => {
    setLoading(true);
    if (refetch) refetch();
    if (refetchArr?.length) {
      refetchArr.forEach((refetchItem) => refetchItem());
    }
    setTimeout(() => setLoading(false), 200);
  };

  useEffect(() => {
    if (tempState) {
      setLoading(true);
      const clickDelay = setTimeout(() => {
        handleRefetch();
      }, 500);
      return () => clearTimeout(clickDelay);
    }
  }, [tempState]);

  return (
    // <Tooltip title='Reload'>
    <Button
      style={{ backgroundColor: '#3AAF85', width: '100%' }}
      onClick={() => setTempState(Math.random())}
      size={reloaderSize || 'middle'}
      type='primary'
      disabled={loading} // Disables button while loading
    >
      {loading ? (
        <LoadingOutlined style={{ fontWeight: 'bolder', fontSize: '20px', color: 'white' }} />
      ) : (
        <ReloadOutlined style={{ fontWeight: 'bolder', fontSize: '20px', color: 'white' }} />
      )}
      Reload
    </Button>
    // </Tooltip>
  );
}
